import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { User } from '../models/user.model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MenuService } from '../services/menu.service';
import { Observable, of } from 'rxjs';
import { Role } from '../models/role.model';

type menuItem = {
  label: string,
  href: string,
  permission?: number,
  icon?: string
}

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    NgFor,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit, OnDestroy, AfterViewChecked {

  @Output() toggleSidebar = new EventEmitter<null>();

  user: User = new User(0, "", "", "", 0, "", "", new Role(0,"","",0));
  //user$: Observable<User | null> = of(this.user)

  userSubscription: any;
  //loggedUser$: Observable<User | null> = of(this.user)

  urlList: menuItem[] = [
    {
      icon: "user.png",
      label: "Konta użytkowników",
      href: '/users-list',
      permission: 1
    },
    {
      icon: "organizations.png",
      label: "Organizacje",
      href: '/organizations-list',
      permission: 1
    },
    {
      icon: "machines.png",
      label: "Lista maszyn",
      href: '/rekbots-list'
    },
    {
      icon: "products.png",
      label: "Produkty",
      href: '/products-list',
      permission: 0
    },
    {
      icon: "products-to-accept.png",
      label: "Produkty do akceptu",
      href: '/temp-products-list',
      permission: 1

    },
    {
      icon: "email.png",
      label: "SMTP",
      href: '/settings-smtp-list',
      permission: 1
    },
    /*{
      label: "Kreator paragonów",
       href: '/receipt-creator'
    },*/

  ];

  constructor(
    public router: Router,
    private authService: AuthService,
    public menuService: MenuService,
    private cd: ChangeDetectorRef
  ) {
    console.log("construct header", this.urlList);

   // this.user$ = of(this.authService.getUser());

    this.userSubscription = this.authService.user$.subscribe({
      next: (user: User | null) => {
        console.log("user", user)
        const role = user?.role || new Role(0, "", "", 0);
        this.user = user || new User(0, "", "", "", 0, "", "", role);
      }
    });
  }

  ngAfterViewChecked(): void {
    //console.log("after view checked")
    this.userSubscription = this.authService.user$.subscribe({
      next: (user: User | null) => {
        //console.log("ngAfterViewChecked user", user)
        const role = user?.role || new Role(0, "", "", 0);
        // console.log("rola po załadowaniu", role);
        this.user = user || new User(0, "", "", "", 0, "", "", role);
      }
    });
    this.cd.detectChanges();
  }

  ngOnInit(): void {
    this.checkAuth()

  }

  ngOnDestroy(): void {
    console.log("destroy")
    this.userSubscription.unsubscribe()
  }

  getCurrentUser() {
    return this.authService.user?.name + " " + this.authService.user?.surname
  }

  checkAuth() {
    if (!this.authService.isAuthenticated) {
      alert("You are not authenticated")
      this.router.navigate([""])
    } else {
      console.log("You are authenticated")
    }
  }

  rekbotSearch: string = "";




  getFilteredUrls(): menuItem[] {
    const currentUser = this.authService.user

    if (currentUser?.is_admin !== undefined && currentUser?.is_admin) {
      return this.urlList
    } else {
      return this.urlList.filter((el) => {
        return el.permission === undefined || el.permission === 0
      })
    }
  }

  getUser() {
    console.log("getUser", this.authService.user)

    this.cd.markForCheck(); // mark for check

    if (this.authService.user?.name === undefined) {
      return this.authService.user?.name + " " + this.authService.user?.surname
    } else {
      return "User"
    }
  }

  openUserProfile() {
    this.router.navigate(['user-profile'])
  }

  logout() {
    this.authService.logout({})
      .subscribe({
        next: (response: any) => {
          console.log("logout response", response)
        }
      })

    localStorage.setItem("_token", "");
    localStorage.setItem("_user", "");

    this.authService.setToken("");
    this.authService.setUser(new User(0, "", "", "", 0, "", "", new Role(0, "", "", 0)));


    this.authService.isAuthenticated = false;
    this.router.navigate([""]);
  }

  isAuthenticated() {
    return this.authService.isAuthenticated;
  }

  onToggleSidebar(){
    this.toggleSidebar.emit()
  }
}
